<script>
import { h, toRefs, computed } from 'vue';

export default {
    props: {
        value: {
            type: Number,
            required: true,
        },
        label: {
            type: String,
            default: null,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100,
        },
        showPct: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const { value, label, min, max, showPct } = toRefs(props);

        const percent = computed(() => {
            const bounded = Math.max(min.value, Math.min(value.value, max.value));
            return 100 * (bounded - min.value) / (max.value - min.value);
        });

        const roundedPercent = computed(() => Math.round(percent.value));

        return () => {
            let bar = h(
                'div',
                {
                    class: 'progress-bar',
                    style: {
                        width: `${percent.value}%`,
                    },
                    role: 'progressbar',
                    'aria-valuenow': value.value,
                    'aria-valuemin': min.value,
                    'aria-valuemax': max.value,
                }
            );
            bar = h('div', { class: 'progress' }, [bar]);

            if (label.value || showPct.value) {
                const lineChildren = [];
                if (label.value) {
                    lineChildren.push(h('div', { class: 'progress-label' }, label.value));
                }
                if (showPct.value) {
                    lineChildren.push(h('div', { class: 'progress-pct' }, `${roundedPercent.value} %`));
                }
                const line = h('div', { class: 'progress-info' }, lineChildren);

                bar = h('div', { class: 'progress-container' }, [line, bar]);
            }
            return bar;
        };
    },
};
</script>
